/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  users: [],
  userProfile: {
    address_line1: '',
    address_line2: '',
    birth_date: '',
    blog: '',
    city: '',
    calendarsList: [],
    contact_by_email: '',
    contact_by_message: '',
    contact_by_phone: '',
    contacts: '',
    country: '',
    email: '',
    facebook: '',
    gender_id: '',
    instagram: '',
    languages: '',
    mobile: '',
    name: '',
    photo: '',
    post_code: '',
    role_name: '',
    skype: '',
    slack: '',
    state: '',
    status_id: '',
    status_name: '',
    twitter: '',
    username: '',
    website: ''
  },
  rolesList: [],
  userAddObject: {
    name: '',
    email: '',
    role_hash: '',
    username: '',
    languages: [],
    is_admin: false,
    external_user: false,
    roleObject: {},
    mobile: ''
  },
  showResetPasswordModal: false,
  currentUserToChangePassword: null,
  userEditObject: {}
}
